import { MealType } from 'proto/Offer/MealType';

const cateringValue: Record<MealType, string> = {
    [MealType.Breakfast]: 'breakfast',
    [MealType.AllInclusive]: 'allinclusive',
    [MealType.AllInclusivePlus]: 'allinclusiveplus',
    [MealType.AllInclusivePremium]: 'allinclusivepremium',
    [MealType.AllInclusiveUltra]: 'allinclusivepremium',
    [MealType.AllInclusiveLight]: 'allinclusivelight',
    [MealType.FullBoard]: 'fullboard',
    [MealType.FullBoardPlus]: 'fullboardplus',
    [MealType.HalfBoard]: 'halfboard',
    [MealType.HalfBoardPlus]: 'halfboardplus',
    [MealType.HalfBoardUltra]: 'halfboardultra',
    [MealType.Special]: 'special',
    [MealType.Program]: 'program',
    [MealType.MealTypeUnknown]: 'unknown',
    [MealType.None]: 'none',
};

const cateringTitle: Record<MealType, string> = {
    [MealType.Breakfast]: 'TRANS-mealtype-breakfast',
    [MealType.AllInclusive]: 'TRANS-mealtype-allinclusive',
    [MealType.AllInclusivePlus]: 'TRANS-mealtype-allinclusiveplus',
    [MealType.AllInclusivePremium]: 'TRANS-mealtype-allinclusivepremium',
    [MealType.AllInclusiveUltra]: 'TRANS-mealtype-allinclusiveultra',
    [MealType.AllInclusiveLight]: 'TRANS-mealtype-allinclusivelight',
    [MealType.FullBoard]: 'TRANS-mealtype-fullboard',
    [MealType.FullBoardPlus]: 'TRANS-mealtype-fullboardplus',
    [MealType.HalfBoard]: 'TRANS-mealtype-halfboard',
    [MealType.HalfBoardPlus]: 'TRANS-mealtype-halfboardplus',
    [MealType.HalfBoardUltra]: 'TRANS-mealtype-halfboardultra',
    [MealType.Special]: 'TRANS-mealtype-special',
    [MealType.Program]: 'TRANS-mealtype-program',
    [MealType.MealTypeUnknown]: 'TRANS-mealtype-unknown',
    [MealType.None]: 'TRANS-mealtype-none',
};

export function getCateringValue(mealType: MealType) {
    return cateringValue[mealType];
}

export function getCateringTitleTranslationKey(mealType: MealType) {
    return cateringTitle[mealType];
}
